export default "__VITE_ASSET__BBoKOl_i__"